import { render, staticRenderFns } from "./RefundRejectCommentModal.vue?vue&type=template&id=0f39e947&"
import script from "./RefundRejectCommentModal.vue?vue&type=script&lang=js&"
export * from "./RefundRejectCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports